import { withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-509413ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "titlebar"
}
const _hoisted_2 = { id: "window-controls" }
const _hoisted_3 = {
  key: 1,
  id: "titlebar-darwin"
}
const _hoisted_4 = { class: "titlebar-buttons-osx" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  name: "TitleBarCloseMac",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "#4c0000",
    fill: "none",
    d: "M8.5,3.5 L6,6 L3.5,3.5 L6,6 L3.5,8.5 L6,6 L8.5,8.5 L6,6 L8.5,3.5 Z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  name: "TitleBarMinimizeMac",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    fill: "#975500",
    width: "8",
    height: "2",
    x: "2",
    y: "5",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isWindows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.canMinimize === true)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button",
                  role: "button",
                  tabindex: "0",
                  "aria-label": "Réduire",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.minimize && _ctx.minimize(...args))),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.minimize && _ctx.minimize(...args)), ["enter"]))
                }, "", 32))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "button button--close",
              role: "button",
              tabindex: "0",
              "aria-label": "Fermer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["enter"]))
            }, "", 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDarwin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            true
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "macButton macButtonClose",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
                }, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "macButton macButtonMinimize",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.minimize()))
            }, _hoisted_8)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}